import { provideRouter, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '',
  },
  
  {
    path: '',
   loadChildren: () => import('./auth/auth.module').then(m=> m.AuthModule)
  },

  {
    path: '',
    loadChildren: () =>import('./features/features.module').then((m) => m.FeaturesModule)
  },

  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
    
];

export const appConfig = {
  providers: [provideRouter(routes)],
};

